export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'امنیت شغلی',
      description: 'قراردادهای دائمی و بیمه کامل در محیطی امن و قانونی با پشتیبانی مستمر از حقوق کارجو',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'استخدام رسمی',
      description: 'موقعیت‌های شغلی در شرکت‌های معتبر با شرایط استخدام رسمی و مزایای کامل',
    },
    {
      icon: 'ri-user-star-line',
      title: 'مشاوره تخصصی',
      description: 'راهنمایی حرفه‌ای توسط مشاوران مجرب برای انتخاب بهترین مسیر شغلی متناسب با توانمندی‌های شما',
    },
  ];

  return (
    <section id="services" className="py-20 md:py-28 bg-carland-light">
      <div className="px-6 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-right mb-16 reveal spring-right" style={{ opacity: 0 }}>
          <span className="text-carland-muted text-sm font-medium tracking-wider">
            راهکارهای تخصصی
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-carland-dark mt-3 leading-tight">
            خدمات حرفه‌ای کاریابی
            <br />
            با تضمین امنیت شغلی
          </h2>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 md:p-10 transition-all duration-400 hover:bg-carland-dark cursor-pointer reveal bounce"
              style={{ opacity: 0, animationDelay: `${0.15 * (index + 1)}s` }}
            >
              <div className="w-14 h-14 rounded-2xl bg-carland-cream flex items-center justify-center mb-6 group-hover:bg-carland-dark/20 transition-colors duration-400">
                <i className={`${service.icon} text-2xl text-carland-dark group-hover:text-white transition-colors duration-400`}></i>
              </div>
              <h3 className="text-xl font-bold text-carland-dark mb-3 group-hover:text-white transition-colors duration-400">
                {service.title}
              </h3>
              <p className="text-carland-muted leading-relaxed text-sm group-hover:text-white/70 transition-colors duration-400">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}